module.exports = __webpack_public_path__ + "images/stickers/heart@2x.315f83d8e396825f0ab7.png";